import {
  FETCH_PROMOCIONES_REQUEST,
  FETCH_PROMOCIONES_SUCCESS,
  FETCH_PROMOCIONES_FAILURE,
} from "../actions/promociones/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROMOCIONES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PROMOCIONES_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_PROMOCIONES_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
